/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useEffect, useState } from 'react'
import MagnifyIcon from 'mdi-react/MagnifyIcon'
import {
  Card,
  CardBody,
  Col,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap'
import { useDebouncedCallback } from 'use-debounce'
import classnames from 'classnames'
import ReactLoading from 'react-loading'
import UsersTable from './UsersTable'
import Modal from './ConfirmationModal'

const Users = ({
  artists,
  curators,
  handleLoginAs,
  handleValidate,
  usersCount: { totalArtists, totalCurators },
  getArtists,
  getCurators,
  allFoundUsers,
  searchUsers,
  blockCurator,
}) => {
  const [isSearch, setIsSearch] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [foundUsers, setFoundUsers] = useState([])
  const [activeTab, setActiveTab] = useState('1')
  const [modal, setModal] = useState(false)
  const [user, setUser] = useState({})
  const [isError, setIsError] = useState(false)
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false)
  const [isModalLoading, setIsModalLoading] = useState(false)

  const toggle = tab => {
    // eslint-disable-next-line no-unused-expressions
    activeTab !== tab ? setActiveTab(tab) : null
  }

  const modalToggle = () => {
    setModal(!modal)
    setIsError(false)
    setIsModalLoading(false)
    setIsSubmitSuccessful(false)
  }

  useEffect(() => {
    setFoundUsers(allFoundUsers.slice(0, 50))
  }, [allFoundUsers])

  const [debouncedCallback] = useDebouncedCallback(value => {
    searchUsers(value, error => {
      if (!error) {
        setTimeout(() => {
          setIsLoading(false)
        }, 500)
      }
    })
  }, 1000)

  const handleFindUser = str => {
    if (!str.length) {
      setIsSearch(false)
    } else {
      setIsLoading(true)
      setIsSearch(true)
      debouncedCallback(str)
    }
  }

  const handleBlockConfirmation = curatorId => {
    isSearch
      ? setUser(foundUsers.find(({ id }) => id === curatorId))
      : setUser(curators.find(({ id }) => id === curatorId))
    modalToggle()
  }

  const handleBlockCurator = curatorId => {
    setIsModalLoading(true)
    blockCurator(curatorId)
    setIsModalLoading(false)
    setIsSubmitSuccessful(true)
  }

  return (
    <>
      <Modal
        fade={false}
        errorMessage="Something went wrong."
        handleSubmit={handleBlockCurator}
        isError={isError}
        isLoading={isModalLoading}
        isSubmitSuccessful={isSubmitSuccessful}
        item={user}
        modal={modal}
        toggle={modalToggle}
        type="block"
      />
      <Row className="users-tab-row">
        <Col lg={6} md={6} xl={3} xs={12}>
          <CardBody className="balance-card">
            <div className="dashboard__booking-total-container">
              <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
                {totalArtists}
              </h5>
            </div>
            <h5 className="dashboard__booking-total-description">
              Total Artists
            </h5>
          </CardBody>
        </Col>
        <Col lg={6} md={6} xl={3} xs={12}>
          <CardBody className="balance-card">
            <div className="dashboard__booking-total-container">
              <h5 className="dashboard__booking-total-title dashboard__booking-total-title--red">
                {totalCurators}
              </h5>
            </div>
            <h5 className="dashboard__booking-total-description">
              Total Curators
            </h5>
          </CardBody>
        </Col>
      </Row>
      <Card className="tabs-wrapper">
        <div className="tabs tabs--bordered-bottom">
          <div className={`tabs__wrap ${isSearch && 'search-tab'} admin-tabs`}>
            {!isSearch && (
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => {
                      toggle('1')
                    }}
                  >
                    Artists &ensp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => {
                      toggle('2')
                    }}
                  >
                    Curators &ensp;
                  </NavLink>
                </NavItem>
              </Nav>
            )}
            <span className="search-wrapper">
              <div className="inbox__emails-control-search">
                <input
                  placeholder="Search"
                  onChange={e => handleFindUser(e.target.value)}
                />
                <div className="inbox__emails-control-search-icon">
                  <MagnifyIcon />
                </div>
              </div>
            </span>
          </div>
        </div>
        <TabContent activeTab={activeTab}>
          {activeTab === '1' && (
            <TabPane tabId="1">
              {isLoading ? (
                <ReactLoading
                  className="users-loading loading"
                  height={24}
                  type="spinningBubbles"
                />
              ) : (
                <UsersTable
                  allFoundUsers={allFoundUsers}
                  getUsers={getArtists}
                  handleBlockConfirmation={handleBlockConfirmation}
                  handleLoginAs={handleLoginAs}
                  handleValidate={handleValidate}
                  isSearch={isSearch}
                  setFoundUsers={setFoundUsers}
                  totalUsers={isSearch ? allFoundUsers.length : totalArtists}
                  users={isSearch ? foundUsers : artists}
                />
              )}
            </TabPane>
          )}
          {activeTab === '2' && (
            <TabPane tabId="2">
              {isLoading ? (
                <ReactLoading
                  className="users-loading loading"
                  height={24}
                  type="spinningBubbles"
                />
              ) : (
                <UsersTable
                  allFoundUsers={allFoundUsers}
                  getUsers={getCurators}
                  handleBlockConfirmation={handleBlockConfirmation}
                  handleLoginAs={handleLoginAs}
                  handleValidate={handleValidate}
                  isSearch={isSearch}
                  setFoundUsers={setFoundUsers}
                  totalUsers={isSearch ? foundUsers.length : totalCurators}
                  users={isSearch ? foundUsers : curators}
                />
              )}
            </TabPane>
          )}
        </TabContent>
      </Card>
    </>
  )
}

export default Users
